import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next';
import { useDeleteFarm, useGetAllFarms } from '../hooks/hooks';
import "react-loading-skeleton/dist/skeleton.css";
import AddFarmModal from '../modal/AddFarmModal';
import { ContactIcon, DeleteIcon, EditIcon, LandmarkIcon, NoDataFarmI } from '../assets/icons/icon';
import { ButtonWithIcon } from '../components/Common/Buttons';
import EntityListPage from '../components/Common/EntityListPage';

function FarmCopy() {
  const { t } = useTranslation();

  const filterFn = useCallback((list, searchText) => {
    if (!searchText.trim()) return list;

    const v = searchText.toLowerCase();

    return list.filter(item =>
      item.farmName?.toLowerCase().includes(v) ||
      item.landmark?.toLowerCase().includes(v) ||
      item.address?.toLowerCase().includes(v)
    );
  }, []);

  const getNoDataDesc = useCallback((searchText) => {
    return searchText ? t('try_adjusting_search_terms') : t('get_started');
  }, []);

  const FarmCard = ({ item, index, onEdit, onDelete }) => (
    <div className="bg-white rounded-xl shadow-card border border-gray-100 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1 p-6">
      <div className="flex justify-between items-start mb-4">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            {item.farmName}
          </h3>
          <div className="space-y-2">
            <div className="flex items-start gap-2">
              <LandmarkIcon />
              <div>
                <p className="text-sm text-gray-600">{item.landmark}</p>
                <p className="text-xs text-gray-500">{item.address}</p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <ContactIcon />
              <span className="text-sm text-gray-600">{item.contactNumber}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <ButtonWithIcon title="Edit" variant='secondary' Icon={EditIcon} iconClass="text-green-600 mr-0" btnclass="p-[5px] hover:bg-green-50 rounded-md transition-all border border-green-300" onClick={onEdit} />
          <ButtonWithIcon title="Edit" variant='secondary' Icon={DeleteIcon} iconClass="w-4 h-4 mr-0 text-red-500" btnclass="p-[5px] text-red-600 hover:bg-red-50 rounded-md border border-red-300" onClick={onDelete} />
        </div>
      </div>
    </div>
  );
  const FarmTableRow = ({ item, index, startIndex, onEdit, onDelete }) => (
    <div
      className={`w-full flex py-4 font-medium text-sm text-gray-700 border-b border-gray-100 hover:bg-gray-50 transition-colors duration-200
           ${index % 2 === 0 ? "bg-gray-50/50" : "bg-white"}`}
    >
      <div className="w-[8%] pl-6 flex items-center font-medium text-gray-500">{startIndex + index + 1}</div>
      <div className="w-[20%] flex items-center pr-4">
        <div className="font-semibold text-gray-900 truncate" title={item.farmName}>{item.farmName}</div>
      </div>
      <div className="w-[18%] flex items-center pr-4">
        <div className="text-gray-700 truncate" title={item.landmark}>{item.landmark}</div>
      </div>
      <div className="w-[22%] flex items-center pr-4">
        <div className="text-gray-700 truncate" title={item.address}>{item.address}</div>
      </div>
      <div className="w-[22%] flex items-center pr-4">
        <span className="text-gray-700 truncate" title={item.contactNumber}>{item.contactNumber}</span>
      </div>
      <div className="w-[10%] flex items-center">
        <div className="flex items-center gap-2">
          <ButtonWithIcon title="Edit" variant='secondary' Icon={EditIcon} btnclass="p-2 text-green-600 hover:bg-green-50 rounded-md transition-all border border-green-300" iconClass="mr-0" onClick={onEdit} />
          <ButtonWithIcon title="Edit" variant='secondary' Icon={DeleteIcon} iconClass="w-4 h-4 mr-0" btnclass="p-2 text-red-600 hover:bg-red-50 rounded-md border border-red-300" onClick={onDelete} />
        </div>
      </div>
    </div>
  );


  return (
    <>
      <EntityListPage
        title={t('farm')}
        subtitle={t('manage_farm_details')}
        addButtonText={t('add_new_farm')}
        searchPlaceholder={t('search_Farm_lbl')}

        fetchHook={useGetAllFarms}
        deleteHook={useDeleteFarm}
        // searchFilter={(list, value) =>
        //   list.filter(f =>
        //     f.farmName.toLowerCase().includes(value.toLowerCase()) ||
        //     f.landmark.toLowerCase().includes(value.toLowerCase()) || 
        //     f.address.toLowerCase().includes(value.toLowerCase())
        //   )
        // }
        filterFn={filterFn}

        tableColumns={[
          { key: "#", label: "#", className: "w-[8%]", width: 50 },
          { key: "name", label: t('farm_name'), className: "w-[20%]", width: 200 },
          { key: "landmark", label: t('landmark'), className: "w-[18%]", width: 150 },
          { key: "address", label: t('address'), className: "w-[22%]", width: 200 },
          { key: "contact", label: t('Contact_Number'), className: "w-[22%]", width: 150 },
          { key: "action", label: t('Action'), className: "w-[10%]", width: 80 },
        ]}

        TableRow={FarmTableRow}
        Card={FarmCard}
        AddEditModal={AddFarmModal}
        buttonText={t('add_farm')}

        emptyIcon={<NoDataFarmI />}
        emptyText="No farms found"
        getNoDataDesc={getNoDataDesc}

        deleteMsg={t('delete_farm_confirmation_msg')}
      />
    </>
  )
}

export default FarmCopy
